import { IconFn, IconSvg } from "../createIcon";

export const DocumentIcon: IconFn = ({ color = "#F56B55", ...props }) => (
  <IconSvg fill="none" viewBox={{ minX: 0, minY: 0, width: 29, height: 30 }} {...props}>
    <path
      d="M3.729.938A3.114 3.114 0 0 0 .604 4.063v21.875a3.114 3.114 0 0 0 3.125 3.125h21.875a3.114 3.114 0 0 0 3.125-3.125V4.063A3.114 3.114 0 0 0 25.604.938H3.729Zm0 3.125h21.875v21.875H3.729V4.063Zm3.125 3.125v3.125h15.625V7.187H6.854Zm0 6.25v3.124h15.625v-3.125H6.854Zm0 6.25v3.125H17.79v-3.125H6.854Z"
      fill={color}
    />
  </IconSvg>
);
